/**
 * ## Payment Status
 * 
 * @type { PENDING | SUCCESS | FAILED | REJECTED | EXPIRED }
 * 
 * @author Pedro Neves
 */
export enum PaymentStatus{

    /**
     * **Peding** - When Payment is still waiting for the user to Pay
     */
    PENDING = "PENDING",

    /**
     * **Success** - When Payment has been Payed Successfully
     */
    SUCCESS = "SUCCESS",

    /**
     * **Failed** - When Payment hasn't been Payed Successfully with for a Reason
     */
    FAILED = "FAILED",

    /**
     * **Rejected** - When Payment has been rejected by the user
     */
    REJECTED = "REJECTED",

    /**
     * **Expired** - When Payment timeout has passed
     */
    EXPIRED = "EXPIRED",

}